import { authApi } from './BaseApiService';
import { ICreatePasswordRequest, IForgetPasswordRequest, IInitPasswordRequest, IInitPasswordResponse, ILoginRequest, LoginResponse } from './model';


export function login(appId: string, data: ILoginRequest) {
  const headers = new Map([
    ['X-Application-Id', appId]
  ]);

  return authApi(headers).post<LoginResponse>(`/auth/company-administrator`, data);
}

export function forgetPassword(appId: string, data: IForgetPasswordRequest) {
  const headers = new Map([
    ['X-Application-Id', appId]
  ]);
  return authApi(headers).post(`/auth/password/company-administrator/reset`, data);
}

export function initNewPass(appId: string, data: IInitPasswordRequest) {
  
  const headers = new Map([
    ['X-Application-Id', appId]
  ]);  
  return authApi(headers).post<IInitPasswordResponse>(`/auth/password/init`, data);
}

export function createNewPass(appId: string, accessToken: string, data: ICreatePasswordRequest) {
  const headers = new Map([
    ['X-Application-Id', appId], ['Authorization', accessToken]
  ]);
  
  return authApi(headers).post(`/auth/password`, data);
}